import "./HeroWithImageText.scss";

import {
  InfoSmallIcon,
  HideFor,
  ConcealableImageText,
} from "/App.Components";
import { PictureProps } from "/Models/Generated/PictureProps";
import { VideoProps } from "/Models/Generated/VideoProps";

interface Props {
  image?: PictureProps;
  video?: VideoProps;
  posterClicked?: boolean;
}

const HeroWithImageText = ({ image, video, posterClicked }: Props) => {
  const showImage = image && !video;
  const showVideo = !!video;

  if (!image && !video) {
    return null;
  }

  return (
    <div className="hero-with-image-text-norad">
      {showImage && (!!image?.imageText || !!image.copyright) && (
        <div className="hero-with-image-text-norad__copyright-and-image-text">
          {!!image.imageText && (
            <ConcealableImageText
              imageText={image.imageText}
              buttonText={image.imageTextButtonText}
            >
              {!!image?.copyright && (
                <HideFor desktop desktopMedium desktopLargeUp>
                  <InfoSmallIcon
                    text={`${image?.copyrightLabel ?? ""} ${image.copyright}`}
                  />
                </HideFor>
              )}
            </ConcealableImageText>
          )}
          {!!image?.copyright && (
            <div className="hero-with-image-text-norad__copyright">
              <HideFor mobile tablet>
                <InfoSmallIcon
                  text={`${image?.copyrightLabel ?? ""} ${image.copyright}`}
                />
              </HideFor>
            </div>
          )}
          {!!image?.copyright && !image?.imageText && (
            <div className="hero-with-image-text-norad__copyright">
              <HideFor desktop desktopMedium desktopLargeUp>
                <InfoSmallIcon
                  text={`${image?.copyrightLabel ?? ""} ${image.copyright}`}
                />
              </HideFor>
            </div>
          )}
        </div>
      )}
      {showVideo && (!!video?.copyright || !!video?.posterImage?.imageText) && (
        <div className="hero-with-image-text-norad__copyright-and-image-text">
          {!!video?.posterImage?.imageText && (
            <ConcealableImageText
              imageText={video?.posterImage?.imageText}
              buttonText={video?.posterImage?.imageTextButtonText}
            >
              {!!video.posterImage?.copyright && !posterClicked && (
                <HideFor desktop desktopMedium desktopLargeUp>
                  <InfoSmallIcon
                    text={`${
                      video.posterImage?.copyrightLabel ?? ""
                    } ${video.posterImage?.copyright}`}
                  />
                </HideFor>
              )}
              {!!video.copyright && posterClicked && (
                <HideFor desktop desktopMedium desktopLargeUp>
                  <InfoSmallIcon
                    text={`${video.copyrightLabel ?? ""} ${video.copyright}`}
                  />
                </HideFor>
              )}
            </ConcealableImageText>
          )}
          {!!video?.copyright && posterClicked && (
            <div className="hero-with-image-text-norad__copyright">
              <HideFor mobile tablet>
                <InfoSmallIcon
                  text={`${video?.copyrightLabel ?? ""} ${video.copyright}`}
                />
              </HideFor>
              {!video?.posterImage?.imageText && (
                <HideFor desktop desktopMedium desktopLargeUp>
                  <InfoSmallIcon
                    text={`${video?.copyrightLabel ?? ""} ${video.copyright}`}
                  />
                </HideFor>
              )}
            </div>
          )}
          {!!video?.posterImage?.copyright && !posterClicked && (
            <div className="hero-with-image-text-norad__copyright">
              <HideFor mobile tablet>
                <InfoSmallIcon
                  text={`${
                    video?.posterImage?.copyrightLabel ?? ""
                  } ${video?.posterImage?.copyright}`}
                />
              </HideFor>
              {!video?.posterImage.imageText && (
                <HideFor desktop desktopMedium desktopLargeUp>
                  <InfoSmallIcon
                    text={`${
                      video?.posterImage?.copyrightLabel ?? ""
                    } ${video?.posterImage?.copyright}`}
                  />
                </HideFor>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default HeroWithImageText;
